import { render, staticRenderFns } from "./ViewSetup.vue?vue&type=template&id=367442a0&"
import script from "./ViewSetup.vue?vue&type=script&lang=ts&"
export * from "./ViewSetup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports